"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GridItem = function GridItem(_ref) {
  var xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: xs,
    sm: sm,
    md: md
  }, children);
};

GridItem.propTypes = {
  /** The mobile column size */
  xs: _propTypes.default.oneOf([false, true, "auto", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /** The tablet column size */
  sm: _propTypes.default.oneOf([false, true, "auto", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /** The desktop column size */
  md: _propTypes.default.oneOf([false, true, "auto", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /** The children element */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.node])
};
GridItem.defaultProps = {
  xs: false,
  sm: false,
  md: false,
  children: null
};
var _default = GridItem;
exports.default = _default;